(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vag-home"] && !Shopify.designMode) return;
  try {
    
function initializeVagHome(root) {
  if (root.dataset.vagInitialized) return;
  const dataNode = root.querySelector('[data-vag-vehicles]');
  const labelNode = root.querySelector('[data-vag-finder-labels]');
  if (!dataNode || !labelNode) return;
  const models = JSON.parse(dataNode.textContent);
  const labels = JSON.parse(labelNode.textContent);
  const modelSelect = root.querySelector('[data-vag-model]');
  const generationSelect = root.querySelector('[data-vag-generation]');
  const form = root.querySelector('[data-vag-finder]');
  const safeUrl = value => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && (/^\/(collections|pages)\//).test(url.pathname) ? url.href : null;
    } catch (error) { return null; }
  };
  models.forEach((model, index) => modelSelect.add(new Option(model.title, String(index))));
  modelSelect.addEventListener('change', () => {
    generationSelect.replaceChildren(new Option(labels.selectGeneration, ''));
    const model = models[Number(modelSelect.value)];
    if (modelSelect.value === '' || !model) { generationSelect.disabled = true; return; }
    generationSelect.disabled = false;
    const choices = model.generations.filter(generation => safeUrl(generation.url));
    if (choices.length) {
      choices.forEach(generation => generationSelect.add(new Option(generation.title, generation.url)));
    } else if (safeUrl(model.url)) {
      generationSelect.add(new Option(model.title, model.url));
    }
    if (generationSelect.options.length === 2) generationSelect.selectedIndex = 1;
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const destination = safeUrl(generationSelect.value);
    if (destination) window.location.assign(destination);
  });
  root.dataset.vagInitialized = 'true';
}
function initializeAllVagHomes() { document.querySelectorAll('.vag-home').forEach(initializeVagHome); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAllVagHomes);
else initializeAllVagHomes();
document.addEventListener('shopify:section:load', initializeAllVagHomes);

  } catch(e) { console.error(e); }
})();
})();
